var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagType,_vm._g(_vm._b({tag:"component",staticClass:"cv-skip-to-content bx--skip-to-content"},'component',_vm.linkProps,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v("Skip to main content")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }